import type { ProjectState } from "@livcg/schema";
import { sendRaw } from "../shared/sendRaw.js";

/**
 * ALL OFF — turns off EVERY on-air surface in one press (the SKORE panic
 * button). There are three call sites (Control Room, Deck, Classic tab), so
 * it lives in one place: the overlay mode, GRID (a separate scene, in the `lineup`
 * replicant) and VAR.
 */
export function allOffSurfaces(slug: string, state: ProjectState): void {
  if (state.overlay.mode) void sendRaw("overlay.hide", { slug, mode: state.overlay.mode });
  if (state.lineup.visible) void sendRaw("lineup.hide", { slug });
  if (state.varOverlay?.visible) void sendRaw("var.hide", { slug });
}
